<template>
  <div class="academy">

  </div>
</template>

<script>
import importSample from '../../components/Academy/sampleBlock.vue';

export default {
    components: {
        importSample,
    },
    data(){
        return{
            loading: false
        }
    },
    methods: {
        sampleFunction() {
            //
        }
    },
    mounted() {
        //
    }
}
</script>
<style lang="scss">

</style>
